import React, { Component } from 'react';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import {Button} from 'rmwc/Button';
import { Select } from 'rmwc/Select';
import SerializeForm from 'form-serialize';
import * as api from '../../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { Radio, Checkbox } from 'rmwc/Radio';
import { Typography } from 'rmwc/Typography';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import GooglePlacesAutoComplete from '../GooglePlacesAutoComplete'
import StatusMessage from '../../util/StatusMessage'
import * as actions from '../../actions'
import PlacesAutoComplete from 'react-places-autocomplete'
import ReactGA from 'react-ga';
import { Card } from 'rmwc/Card';
import PaginationComponent from '../PaginationComponent';
import menuIcon from '../../assets/images/Menu.png'

class CentaTPOResults extends Component {

  constructor(props){
    super(props);
    this.state={
      navBarComponent: 'top500',
      errorMsg: '',
      yearList: [],
      tpoYear: '',
    }
  }

  handleNavBarChange = (navBarComponent) => {
    this.setState({navBarComponent: navBarComponent})
  }

  handleMobileMenu() {
    var x = document.getElementById("topnav");
    if (x.className === "topnav") {
      x.className += " responsive";
    } else {
      x.className = "topnav";
    }
  }


  render() {
    let topBarComponent;
    topBarComponent = (
      <div className="topnav" id="topnav">
          <a style={{ backgroundColor: this.state.navBarComponent == "top500" ? "#e1c678": "", color: this.state.navBarComponent == "top500" ? "black": ""}} onClick={()=>{this.handleNavBarChange('top500')}}>
           Overall Ranks
          </a>
          <a style={{ backgroundColor: this.state.navBarComponent == "subject" ? "#e1c678": "", color: this.state.navBarComponent == "subject" ? "black": ""}} onClick={()=>{this.handleNavBarChange('subject')}}>
            Subject Toppers
          </a>
          <a style={{ backgroundColor: this.state.navBarComponent == "region" ? "#e1c678": "", color: this.state.navBarComponent == "region" ? "black": ""}} onClick={()=>{this.handleNavBarChange('region')}}>
            Regional Toppers & Rank Holders
          </a>
          {/*<a style={{ backgroundColor: this.state.navBarComponent == "city" ? "#e1c678": "", color: this.state.navBarComponent == "city" ? "black": ""}} onClick={()=>{this.handleNavBarChange('city')}}>
            City Toppers & Rank Holders
          </a>*/}
          <a style={{ backgroundColor: this.state.navBarComponent == "tei" ? "#e1c678": "", color: this.state.navBarComponent == "tei" ? "black": ""}} onClick={()=>{this.handleNavBarChange('tei')}}>
            Winners from B.Ed. Category
          </a>
          <a style={{ backgroundColor: this.state.navBarComponent == "search" ? "#e1c678": "", color: this.state.navBarComponent == "search" ? "black": ""}} onClick={()=>{this.handleNavBarChange('search')}}>
            Search by Name/ Organization
          </a>
          <a href="#" className="icon" onClick={this.handleMobileMenu}>
            <img src={menuIcon} style={{width: '50%', height: '50%'}}/>
          </a>
      </div>
    )

    let displayComponent;
    let navBarComponent = this.state.navBarComponent;
    if(navBarComponent === 'subject'){
      displayComponent = (<SubjectToppers  key={this.state.tpoYear} tpoYear={this.state.tpoYear} />)
    } else if (navBarComponent === 'top500'){
      displayComponent = (<TPOTopRankHolders key={this.state.tpoYear} tpoYear={this.state.tpoYear}/>)
    } else if (navBarComponent === 'region') {
      displayComponent = (<RegionalToppers key={this.state.tpoYear} tpoYear={this.state.tpoYear} />)
    } else if (navBarComponent === 'city') {
      displayComponent = (<CityToppers key={this.state.tpoYear} tpoYear={this.state.tpoYear} />)
    } else if (navBarComponent === 'tei') {
      displayComponent = (<TEIComponent key={this.state.tpoYear} tpoYear={this.state.tpoYear} />)
    } else if (navBarComponent === 'search') {
      displayComponent = (<SearchResults yearList={this.state.yearList} tpoYear={this.state.tpoYear} />)
    }
    return (
      <div style={{backgroundColor: '#ffffff'}}> 
        {topBarComponent}
        {displayComponent}
        <GridCell span="12"><StatusMessage error_msg = {this.state.errorMsg}/></GridCell>
      </div>
    )
  }
}

class TPOTopRankHolders extends Component {

  constructor(props){
    super(props);
    this.state = {
      itemsPerPage: 50,
      totalCount: '',
      rankCount: 500,
      tpoYear: '',
      data: {
        topRankHolders: [],
      },
      errorMsg: ''
    }
  }

  fetchTPORankHolderDetails = (pageNo) => {
    let data = Object.assign({}, this.state.data)
    api.getTPOTopRankHolders(this.state.rankCount,this.state.tpoYear,pageNo,this.state.itemsPerPage)
    .then((result) => {
      if(result.status === 'success'){
        data.topRankHolders = result.data
        this.setState({
          data: data,
          totalCount: result.overall_toppers_count
        })
      }
      else {
        this.setState({
          errorMsg: result.data
        })
      }
    })
  }

  handleTPOYear = (year) => {
    let data = Object.assign({}, this.state.data)
    api.getTPOTopRankHolders(this.state.rankCount,year,1,this.state.itemsPerPage)
    .then((result) => {
      if(result.status === 'success'){
        data.topRankHolders = result.data
        this.setState({
          data: data,
          totalCount: result.overall_toppers_count,
          tpoYear: year
        })
      }
      else {
        this.setState({
          errorMsg: result.data
        })
      }
    })
  }

  render() {
    let paginationKey = this.state.totalCount
    let tableComponent;
    if(this.state.data.topRankHolders){
      tableComponent = (<React.Fragment>
        {this.state.data.topRankHolders.map(function (rankHolder) {
          return (<tr key={rankHolder.id}>
            <td>{rankHolder.national_rank}</td>
            <td>{rankHolder.subject_track}</td>
            <td>{rankHolder.name}</td>
            <td>{rankHolder.organization}</td>
            <td>{rankHolder.test_city}</td>
          </tr>)
        })}
        </React.Fragment>
      )
    }
    return(
     <div style={{backgroundColor: '#ffffff'}}>
        <Grid>
          <GridCell span="6">
            <Typography use="headline6">Winners & Rank Holders of CENTA TPO</Typography>
            <SearchByYear handleTPOYear={this.handleTPOYear}/>
          </GridCell>
          <GridCell span="12">
            {/*<Typography use="headline6">Top 500 National Rank Holders</Typography>*/}
            <Typography use="headline6">Overall Rank Holders</Typography>
          </GridCell>
        </Grid>
        <Grid>
          <GridCell span="12">
            <Card style={{padding: '10px', backgroundColor: '#16355c',color: '#ffffff',marginBottom: '5px'}} >
              <Typography use="headline5"><b>Overall Rank Holders</b></Typography>
              <div style={{backgroundColor: '#ffffff', color: '#000000', overflow: 'scroll'}}  >
                <table>
                  <tbody>
                    <tr>
                      <th>Rank</th>
                      <th>Subject Track</th>
                      <th>Name</th>
                      <th>School</th>
                      <th>Test City</th>
                    </tr>
                    {tableComponent}
                  </tbody>
                </table>
                <div key={paginationKey}>
                  <PaginationComponent totalItems = {this.state.totalCount}
                    itemsPerPage = {this.state.itemsPerPage} 
                    onHandleItemsFetch = {this.fetchTPORankHolderDetails} />
                </div>
              </div>
            </Card>
          </GridCell>
        </Grid>
        <GridCell span="12"><StatusMessage error_msg = {this.state.errorMsg}/></GridCell>
      </div>
    )
  }
}

class SubjectToppers extends Component {

  constructor(props){
    super(props);
    this.state = {
      tpoYear: ''
    }
  }

  handleTPOYear = (year) => {
    this.setState({tpoYear: year})
  }

  render() {

    return(
      <div style={{backgroundColor: '#ffffff'}}>
        <Grid>
          <GridCell span="6">
            <Typography use="headline6">Winners & Rank Holders of CENTA TPO</Typography>
            <SearchByYear handleTPOYear={this.handleTPOYear}/>
          </GridCell>
          <GridCell span="12">
            <Typography use="headline6">Subject Toppers</Typography>
          </GridCell>
        </Grid>
        <Grid>
          <GridCell span="12">
            <AccordionList type= "subject" key={this.state.tpoYear&& this.state.tpoYear} tpoYear={this.state.tpoYear&& this.state.tpoYear}/>
          </GridCell>
        </Grid>
      </div>
    )
  }
}

class RegionalToppers extends Component {

  constructor(props){
    super(props);
    this.state = {
      tpoYear: '',
    }
  }

  handleTPOYear = (year) => {
    this.setState({tpoYear: year})
  }

  render() {
    return(
      <div style={{backgroundColor: '#ffffff'}}>
        <Grid>
          <GridCell span="6">
            <Typography use="headline6">Winners & Rank Holders of CENTA TPO</Typography>
            <SearchByYear handleTPOYear={this.handleTPOYear}/>
          </GridCell>
          <GridCell span="12">
            <Typography use="headline6">Regional Toppers & Rank Holders</Typography>
          </GridCell>
        </Grid>
        <Grid>
          <GridCell span="12">
            <AccordionList type= "regional" key={this.state.tpoYear&& this.state.tpoYear} tpoYear={this.state.tpoYear&& this.state.tpoYear}/>
          </GridCell>
        </Grid>
      </div>
    )
  }
}

class CityToppers extends Component {

  constructor(props){
    super(props);
    this.state = {
      tpoYear: '',
    }
  }

  handleTPOYear = (year) => {
    this.setState({tpoYear: year})
  }

  render() {

    return(
      <div style={{backgroundColor: '#ffffff'}}>
        <Grid>
          <GridCell span="6">
            <Typography use="headline6">Winners & Rank Holders of CENTA TPO</Typography>
            <SearchByYear handleTPOYear={this.handleTPOYear}/>
          </GridCell>
          <GridCell span="12">
            <Typography use="headline6">City Toppers & Rank Holders</Typography>
          </GridCell>
        </Grid>
        <Grid>
          <GridCell span="12">
            <AccordionList type= "city" key={this.state.tpoYear&& this.state.tpoYear} tpoYear={this.state.tpoYear&& this.state.tpoYear}/>
          </GridCell>
        </Grid>
      </div>
    )
  }
}

class TEIComponent extends Component {

  constructor(props){
    super(props);
    this.state = {
      tpoYear: ''
    }
  }

  handleTPOYear = (year) => {
    this.setState({tpoYear: year})
  }

  render() {
    return(
      <div style={{backgroundColor: '#ffffff'}}>
        <Grid>
          <GridCell span="6">
            <Typography use="headline6">Winners & Rank Holders of CENTA TPO</Typography>
            <SearchByYear handleTPOYear={this.handleTPOYear}/>
          </GridCell>
          <GridCell span="12">
            <Typography use="headline6">Winners from B.Ed. Category</Typography>
          </GridCell>
        </Grid>
        <Grid>
          <GridCell span="12">
            <AccordionList type= "tei" key={this.state.tpoYear&& this.state.tpoYear} tpoYear={this.state.tpoYear&& this.state.tpoYear}/>
          </GridCell>
        </Grid>
      </div>
    )
  }
}

class AccordionList extends Component {

  constructor(props){
    super(props);
    this.state={
      activeDiv: '',
      typeList: '',
      errorMsg: '',
    }
  }

  componentDidMount() {
    if(this.props.tpoYear) {
      if(this.props.type === 'subject'){
        return api.getTPOSubjectToppers(this.props.tpoYear)
        .then((result) => {
          if(result.status === 'success'){
            this.setState({
              typeList: result.data,
            })
          }
          else {
            this.setState({
              errorMsg: result.data
            })
          }
        })
      }
      else if(this.props.type === 'regional') {
        return api.getTPORegionalToppers(this.props.tpoYear)
        .then((result) => {
          if(result.status === 'success'){
            this.setState({
              typeList: result.data,
            })
          }
          else {
            this.setState({
              errorMsg: result.data
            })
          }
        })
      }
      else if(this.props.type === 'city') {
        return api.getTPOCityToppers(this.props.tpoYear)
        .then((result) => {
          if(result.status === 'success'){
            this.setState({
              typeList: result.data,
            })
          }
          else {
            this.setState({
              errorMsg: result.data
            })
          }
        })
      }
      else if(this.props.type === 'tei') {
        return api.getTPOTEIToppers(this.props.tpoYear)
        .then((result) => {
          if(result.status === 'success'){
            this.setState({
              typeList: result.data, activeDiv: 'TEI'
            })
          }
          else {
            this.setState({
              errorMsg: result.data
            })
          }
        })
      }
    }
  }

  handleExpansion = (e, value) => {
    if(this.state.activeDiv === value){
      this.setState({activeDiv: ''})
    }
    else{
      this.setState({activeDiv: value})
    }
    
  }

  render() {
    let handleExpansion = this.handleExpansion
    let activeDiv = this.state.activeDiv
    let listComponent;
    let typeList = this.state.typeList
    let propsInputType = this.props.type
    let colName = "Subject Track"
    if(propsInputType === 'subject'){
      colName = "Region"
    }
    
    listComponent = (
      <GridCell span="12">
        {Object.keys(typeList).map(function (type){
          let type_val = typeList[type]
          if(type==="TEI"){
            type ="B.Ed"
          }
          return (<Card key={type} style={{padding: '10px', backgroundColor: '#16355c',color: '#ffffff',marginBottom: '5px'}} onClick={((e) => handleExpansion(e, type))}>
            <div>
              <Typography use="headline6"><b>{type}</b></Typography>
              <i  className="material-icons mdc-list-item__graphic topper-list-expan-icon" aria-hidden="true">keyboard_arrow_down</i>
            </div>
            <div style={{backgroundColor: '#ffffff', color: '#000000', overflow: 'scroll', height: '400px'}} className={ activeDiv === type ? "showdiv" : "hidediv"} >
              <table >
                <tbody>
                  <tr>
                    <th>Rank</th>
                    <th>{colName}</th>
                    <th>Name</th>
                    <th>School/Organization/College</th>
                    <th>Test City</th>
                  </tr>
                    {type_val.map(function(val){
                      let rankColumn, typeColumn
                      if(propsInputType === 'regional'){
                        rankColumn = val.region_rank
                        typeColumn =  val.subject_track
                      }
                      else if(propsInputType === 'subject'){
                        rankColumn = val.subject_rank
                        typeColumn = val.region
                      }
                      else if(propsInputType === 'city'){
                        rankColumn = val.test_city_rank
                        typeColumn = val.subject_track
                      }
                      else if(propsInputType === 'tei'){
                        rankColumn = val.tei_rank
                        typeColumn = val.subject_track
                      }
                      return (
                        <tr key={val.id}>
                          <td>{rankColumn}</td>
                          <td>{typeColumn}</td>
                          <td>{val.name}</td>
                          <td>{val.organization}</td>
                          <td>{val.test_city}</td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          </Card>)
        })}
      </GridCell>
    )
    return(
      <Grid>
        {listComponent}
        <GridCell span="12"><StatusMessage error_msg = {this.state.errorMsg}/></GridCell>
      </Grid>
    )
  }
}

class SearchResults extends Component {

  constructor(props){
    super(props);
    this.state = {
      tpoYear: '',
      yearList: [],
      totalCount: '',
      searchData : {
        searchTerm: '',
        searchYear: '',
      },
      errors: {
        searchErrorMsg: '',
        searchYearMsg: '',
      },
      itemsPerPage: 50,
      totalCount: '',
      searchResults: [],
    }
  }

  componentDidMount() {
    return api.getTPOYears()
    .then((result) => {
      if(result.status === 'success'){
        this.setState({
          yearList: result.data,
          tpoYear: result.data[0].year
        })
      }
      else {
        this.setState({
          errorMsg: result.data
        })
      }
    })
  }

  onInputChange = (e) => {
    let data = Object.assign({}, this.state.searchData)
    data[e.target.name] = e.target.value
    this.setState({searchData: data})
  }

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.errors)
    let data = Object.assign({}, this.state.searchData)

    errorObj.searchErrorMsg = ''
    errorObj.searchYearMsg = ''
    if(!data.searchTerm){
      errorObj.searchErrorMsg ='Search field should not be empty'
      error = false
    } else if(data.searchTerm.length < 3) {
      errorObj.searchErrorMsg ='Search term should contain minimum of 3 characters'
      error = false
    }

    if(!data.searchYear){
      errorObj.searchYearMsg ='Search year should not be empty'
      error = false
    }
    this.setState({
      errors: errorObj,
      errorMsg: '',
    })
    return error
  }

  handleSearchQuery = (e) => {
    e.preventDefault() 
    if(this.validateForm()){
      this.fetchSearchDetails(1)
    }
  }

  fetchSearchDetails = (pageNo) => {
    let errorObj = Object.assign({}, this.state.errors)
    let data = Object.assign({}, this.state.searchData)
    api.getTPOSearchResults(data.searchTerm, data.searchYear,pageNo, this.state.itemsPerPage)
    .then((result) => {
      if(result.status === 'success'){
        errorObj.searchErrorMsg = ''
        errorObj.searchYearMsg = ''
        this.setState({searchResults: result.data, errors: errorObj, totalCount: result.overall_toppers_count})
      }
      else {
        this.setState({
          errorMsg: result.data
        })
      }
    })
  }

  handleClear = () => {
    let data = Object.assign({}, this.state.searchData)
    data.searchTerm = ''
    data.searchYear = ''
    this.setState({searchResults: '',searchData: data})
  }

  render() {
    let paginationKey = this.state.totalCount
    let tableComponent;
    let searchDetails = this.state.searchResults
    tableComponent = (
      <GridCell span="12">
      {Object.keys(searchDetails).map(function (search){
        let search_val = searchDetails[search]
        return(
          <Card style={{backgroundColor: '#ffffff', color: '#000000', overflow: 'scroll'}}>
          <div align="center"><Typography use="headline6">{search}</Typography></div>
          <table>
            <th>Overall Rank</th>
            <th>Subject Track</th>
            <th>Name</th>
            <th>School/Organization/College</th>
            <th>Regional Rank</th>
            <th>Subject Rank</th>
            <th>B.Ed Rank</th>
            <th>Test City</th>
            <tbody>
              {search_val.map(function (rankHolder) {
                return (<tr>
                  <td>{rankHolder.national_rank}</td>
                  <td>{rankHolder.subject_track}</td>
                  <td>{rankHolder.name}</td>
                  <td>{rankHolder.organization}</td>
                  <td>{rankHolder.region_rank}</td>
                  <td>{rankHolder.subject_rank}</td>
                  <td>{rankHolder.tei_rank}</td>
                  <td>{rankHolder.test_city}</td>
                </tr>)
              })}
            </tbody>
          </table>
          </Card>)
      })}
      </GridCell>
    )
    return(
      <div style={{backgroundColor: '#ffffff'}}>
        <Grid>
          <GridCell span="4">
            <TextField
              className='admin-reg-filter-criteria'
              label="Search by Name/Organization"
              autoComplete="off"
              name="searchTerm"
              fullwidth
              onChange={this.onInputChange}
              value={this.state.searchData.searchTerm}
              style={{paddingTop: '15px'}}
            />
          </GridCell>
          <GridCell span="4">
            <Select
              name="searchYear"
              fullwidth
              onChange={this.onInputChange} 
              value={this.state.searchData.searchYear}
              placeholder="-- Select TPO year --" 
            >
              {this.state.yearList && this.state.yearList.map(criteria => (
                <option value={criteria.year} data-name={criteria.year}>
                  {criteria.year}
                </option>
              ))}
            </Select>
          </GridCell>
          <GridCell span="2" phone="2" style={{paddingTop: '10px'}}>
            <Button className="add-opportunity" onClick={this.handleSearchQuery}>
              Search
            </Button>
          </GridCell>
          <GridCell span="2" phone="2" style={{paddingTop: '10px'}}>
            <Button className="add-opportunity" onClick={this.handleClear}>
              Clear
            </Button>
          </GridCell>
          <GridCell span="12"><StatusMessage error_msg = {this.state.errors.searchErrorMsg}/></GridCell>
          <GridCell span="12"><StatusMessage error_msg = {this.state.errors.searchYearMsg}/></GridCell>
        </Grid>
        <Grid>
          <GridCell span="12">
            <Typography use="headline6">Winners & Rank Holders of CENTA TPO</Typography>
          </GridCell>
          <GridCell span="12">
            <Typography use="headline6">Search Results</Typography>
          </GridCell>
        </Grid>
        <Grid>
          <GridCell span="12">
            <Card>
              {tableComponent}
            </Card>
          </GridCell>
          <GridCell span="12">
            <div key={paginationKey}>
              <PaginationComponent
                totalItems = {this.state.totalCount}
                itemsPerPage = {this.state.itemsPerPage} 
                onHandleItemsFetch = {this.fetchSearchDetails} 
              />
            </div>
          </GridCell>
        </Grid>
      </div>
    )
  }
}

class SearchByYear extends Component {
    constructor(props){
    super(props);
    this.state={
      yearList: [],
      tpoYear: '2019',
    }
  }

  componentDidMount() {
    return api.getTPOYears()
    .then((result) => {
      if(result.status === 'success'){
        this.setState({
          yearList: result.data,
          tpoYear: result.data[0].year
        })
        this.props.handleTPOYear(result.data[0].year)
      }
      else {
        this.setState({
          errorMsg: result.data
        })
      }
    })
  }

  handleSearchCriteriaChange = (e) => {
    this.setState({tpoYear: e.target.value})
    this.props.handleTPOYear(e.target.value, this.state.yearList)
  }

  render() {
    return(
      <React.Fragment>
        <GridCell span="6" style={{paddingTop: '10px'}}>
          <Typography><b>Search by TPO year:</b></Typography>
          <Select 
            onChange={this.handleSearchCriteriaChange} 
            value={this.state.tpoYear}
            className="admin-reg-filter-section"
            placeholder="-- Search by TPO year --" 
          >
            {this.state.yearList.map(criteria => (
              <option key={criteria.year} value={criteria.year} data-name={criteria.year}>
                {criteria.year}
              </option>
            ))}
          </Select>
        </GridCell>
      </React.Fragment>
    )
  }
}

function mapStateToProps() {
  
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
} 

export default connect(mapStateToProps, mapDispatchToProps)(CentaTPOResults);


// WEBPACK FOOTER //
// ./src/views/centa/CentaTPOResults.jsx